<script setup>
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import ActivityLogTable from "@/components/kit-activity-log/partials/ActivityLogTable.vue";
import ActivityLogTableHeader from "@/components/kit-activity-log/partials/ActivityLogTableHeader.vue";
import {handlePageChange, useKitActivityLogs} from "@/composables/kit-activity-logs/useKitActivityLogs";
import PaginationButtons from "@/components/global-themed/PaginationButtons.vue";
import {kitName} from "@/composables/useLocalDomains";

const {currentPage, queryMeta} = useKitActivityLogs();
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center tw-gap-4">
          <KitIcon class="tw-h-14" />
          <h1 class="tw-font-bold tw-text-4.5xl tw-text-neutral-900">
            {{ kitName }} Changelog
          </h1>
        </div>
      </div>

      <div
        class="tw-bg-white tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-gap-y-8 tw-items-center"
      >
        <ActivityLogTableHeader />
        <ActivityLogTable />
        <PaginationButtons
          :last-page="queryMeta.last_page"
          :current-page="currentPage"
          @change="(page) => handlePageChange(page)"
        />
      </div>
    </div>
  </div>
</template>
